import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild } from '@angular/router';
import { SessionService } from './session.service';
import { Observable } from 'rxjs';

@Injectable()
export class RouterAuthorizerService implements CanActivate, CanActivateChild {

  constructor(private _sessionService: SessionService, private _router: Router) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.checkAuthentication(route, state);
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.checkAuthorization(route, state);
  }

  checkAuthentication(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    return new Promise(async (resolve, reject) => {
      const isLoggedIn = await this._sessionService.isAuthenticated();
      if (!isLoggedIn) {
        this._router.navigate(['/public/login'], { queryParams: { redirectUrl: state.url }});
        resolve(false);
      } else {
        resolve(true);
      }
    });
  }

  checkAuthorization(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    return new Promise((resolve, reject) => {
      console.log(route.routeConfig, this._sessionService.getCurrentAccount());
      if (route.routeConfig.path == 'unavailable' || route.routeConfig.path == 'contactAdmin') {
        console.log('Routing to ', route.routeConfig);
        resolve(true);
      } else if (this._sessionService.getCurrentAccount() && this._sessionService.isExpiredTrial() && route.routeConfig.path != '') {
        console.log('Trial period is expired. Route:', route.routeConfig);
        if (this._sessionService.isSubAccount()) {
          this._router.navigate(['/secured/contactAdmin']);
        } else {
          this._router.navigate(['/secured/unavailable']);
        }
        resolve(false);
      } else if (this._sessionService.getCurrentAccount() &&
                  !this._sessionService.isAccountType('SYSTEM') &&
                  (this._sessionService.getInstanceStatus() != 'active' || this._sessionService.getPaymentStatus() == 'missing' || this._sessionService.getPaymentStatus() == 'cancelled') &&
                  route.routeConfig.path != '') {
        console.log('Account instance is not active. Route:', route.routeConfig);
        this._router.navigate(['/secured/unavailable']);
        resolve(false);
      } else {
        let isAuthorized = true;
        if (route.data.feature) {
          isAuthorized = this._sessionService.hasFeature(route.data.feature);
        }
        if (route.data.notFeature) {
          isAuthorized = !this._sessionService.hasFeature(route.data.feature);
        }
        if (route.data.accountType) {
          isAuthorized = this._sessionService.getCurrentAccount().type === route.data.accountType;
        }
        if (isAuthorized && route.data.requiredRoles) {
          for (const roleGroup of route.data.requiredRoles) {
            if (!this.checkRoleGroup(roleGroup)) {
              isAuthorized = false;
              break;
            }
          }
        }
        if (!isAuthorized) {
          // If authorization failed, we want to clear the stored cognito user session
          // to force a new login.
          console.log('User attempted to access an unauthorized route. Route:', route.routeConfig);
          this._sessionService.logout();
          let qp = {};
          qp['autoSso'] = false;
          this._router.navigate(['/public/login'], { queryParams: qp });
        }
        resolve(isAuthorized);
      }
    });
  }

  private checkRoleGroup(roleGroup: string[]): boolean {
    let isAuthorized = false;
    for (const reqRole of roleGroup) {
      if (this._sessionService.hasRole(reqRole)) {
        isAuthorized = true;
      }
    }
    return isAuthorized;
  }

}
